import { ServiceInformationProps } from '@/modules/Service/types'
import React from 'react'
import ServiceStatement from '../../../shared/ServiceStatement'
import ServiceCommitment from './Commitment'

const Information: React.FC<ServiceInformationProps> = ({ service }) => {
    // const { data, isError, error, isLoading, isPending } = useQuery({
    //     queryKey: ['services.configoptions', service?.service_id],
    //     queryFn: () => getServiceConfigoptions({ serviceID: service?.service_id }),
    // })

    // if (isError) return <AlertError error={error} />
    // if (isLoading || isPending) return <Loading.CircularProgress width={20} height={20} />

    return (
        <div className="px-4 py-2">
            <ServiceStatement serviceID={service?.service_id} />
            <ServiceCommitment />
        </div>
    )
}

export default Information
